export function isDaySelected(daySelection, row, index) {
	return (daySelection || []).some((d) => d.row === row && d.index === index);
}

export function setDaySelected(daySelection, row, index, selected) {
	const current = daySelection || [];
	const exists = isDaySelected(current, row, index);

	if (selected) {
		return exists ? current : [...current, { row, index }];
	}

	if (!exists) {
		return current;
	}

	return current.filter((d) => !(d.row === row && d.index === index));
}

export function setAssignmentDayChecked(planAssignments, row, index, checked) {
	if (!Array.isArray(planAssignments) || !planAssignments[row]) {
		return planAssignments;
	}

	return planAssignments.map((assignment, r) => {
		if (r !== row) {
			return assignment;
		}

		return {
			...assignment,
			plans: (assignment.plans || []).map((plan, i) =>
				i === index ? { ...plan, checked } : plan
			),
		};
	});
}

export function nextCheckedFromDayClick(event, alreadySelected) {
	const target = event?.currentTarget;

	if (target?.classList?.contains("shift-item")) {
		return !alreadySelected;
	}

	if (typeof event?.target?.checked === "boolean") {
		return event.target.checked;
	}

	return !alreadySelected;
}

export function rowSelectionSignature(daySelection, rowIndex) {
	return (daySelection || [])
		.filter((d) => d.row === rowIndex)
		.map((d) => d.index)
		.sort((a, b) => a - b)
		.join(",");
}

const INTERNAL_SHIFT_DRAG_TYPE = "application/x-shift-plan";

export function isInternalShiftPlanDrag(event) {
	const types = event?.dataTransfer?.types;
	if (!types) return false;
	return Array.from(types).includes(INTERNAL_SHIFT_DRAG_TYPE);
}

export function parseInternalShiftPlanDropPayload(raw) {
	if (!raw || typeof raw !== "string") return null;
	try {
		const shiftPlan = JSON.parse(raw);
		if (shiftPlan?.shift_plan && shiftPlan?.employee) {
			return shiftPlan;
		}
	} catch (_) {
		// Texto del navegador al arrastrar desde el sidebar (p. ej. "08:00-17:00").
	}
	return null;
}

/** Payload solo si el drag viene de un turno ya asignado en la rejilla. */
export function getInternalShiftPlanFromDropEvent(event, draggedPlanSelector) {
	if (!isInternalShiftPlanDrag(event)) {
		return null;
	}

	const dataTransfer = event.dataTransfer;
	const candidates = [
		dataTransfer.getData("shift"),
		dataTransfer.getData("text/plain"),
		dataTransfer.getData("application/json"),
	];

	for (const raw of candidates) {
		const parsed = parseInternalShiftPlanDropPayload(raw);
		if (parsed) return parsed;
	}

	const selector = draggedPlanSelector || "[data-drag-plan]";
	const draggedElement = document.querySelector(selector);
	if (draggedElement) {
		return parseInternalShiftPlanDropPayload(
			draggedElement.getAttribute("data-drag-plan")
		);
	}

	return null;
}

export function resolvePasteDaySelection(daySelection, dropTarget) {
	const selected = daySelection || [];
	const hasValidDrop =
		dropTarget &&
		Number.isInteger(dropTarget.row) &&
		Number.isInteger(dropTarget.index);

	if (selected.length > 0) {
		if (
			!hasValidDrop ||
			isDaySelected(selected, dropTarget.row, dropTarget.index)
		) {
			return selected;
		}

		return [...selected, { row: dropTarget.row, index: dropTarget.index }];
	}

	if (hasValidDrop) {
		return [{ row: dropTarget.row, index: dropTarget.index }];
	}

	return [];
}
